var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50002 1.69794L7.45194 3.6423L2.7345 8.35974L0.79014 6.41538L5.50002 1.69794ZM0.19566 8.70666C0.185816 8.77556 0.209723 8.8454 0.25941 8.89415C0.307691 8.94478 0.378004 8.96822 0.44691 8.9579L2.08563 8.7704L0.38127 7.06233L0.19566 8.70666ZM8.12502 1.79922L7.34502 1.01922C7.1908 0.864524 6.98128 0.777344 6.76283 0.777344C6.54439 0.777344 6.33486 0.864531 6.18064 1.01922L6.03251 1.16734L7.98251 3.1117L8.13064 2.96358C8.28533 2.80935 8.37251 2.59983 8.37251 2.38138C8.37251 2.16295 8.28532 1.95342 8.13064 1.79919L8.12502 1.79922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.a7cf9176500571daa609cd37f3772af3.svg";
export { ForwardRef as ReactComponent };